import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, inject } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { TextService } from 'src/app/services/text.service';
import { EmailRadioValues } from '../teuda/teuda.component';
import { UserService } from 'src/app/services/user.service';
import { BehaviorSubject, Observable, Subject, combineLatest, map, startWith, takeUntil, take } from 'rxjs';
import { SeeOneHov } from 'src/app/Interfaces/SQL-reports-responses';
import { SearchInputComponent } from '../search-input/search-input.component';
import { genericSearchingFunctionWithoutNullChecks } from 'src/app/Utility/functions';
import { Product } from 'src/app/Interfaces/product';
import { decompress } from 'lz-string';

type SeeOneHovWithItemPic = SeeOneHov & { ItemPicName?: string };

@Component({
	selector: 'app-clienthovoteach',
	templateUrl: './clienthovoteach.component.html',
	styleUrls: ['./clienthovoteach.component.scss'],
})
export class ClienthovoteachComponent implements OnInit, AfterViewInit, OnDestroy {
	_ss = inject(StoreService);
	_text = inject(TextService);
	_user = inject(UserService);
	private router = inject(Router);
	private fb = inject(FormBuilder);
	constructor() {}

	@ViewChild(SearchInputComponent) searchInputComponent: SearchInputComponent;

	public form: FormGroup;
	public EachClientEachHov;
	EachClientEachHov$ = new BehaviorSubject<SeeOneHovWithItemPic[]>([]);
	searchInputValue = new BehaviorSubject<string>('');
	EachClientEachHovDisplay$ = this.EachClientEachHov$.asObservable();

	OneClientInfo;

	addressToDisplay =
		this._ss.OneClientInfo?.Address && this._ss.OneClientInfo?.CustCity
			? `${this._ss.OneClientInfo.Address}, ${this._ss.OneClientInfo.CustCity}`
			: this._ss.OneClientInfo?.Address || this._ss.OneClientInfo?.CustCity || '';
	// If both undefined for some reason

	doesPDFExistInServer = false;
	pdfFolderLookup = this._ss.CustomerInformation.PDFDirectory;
	pdfFilepath;

	history = history;

	isEmailPickPopupOpen = false;

	clientHasEmail = false;

	windowWidth = window.innerWidth;

	emailRadios = new FormControl<EmailRadioValues>('client');
	emailInput = new FormControl('', [Validators.required, Validators.email]);

	showItemInPack = true;

	public Admin;

	allProducts$ = new BehaviorSubject<Product[]>([]);
	allProductsRecord$ = this.allProducts$.pipe(
		map(products =>
			this._ss.AllProductsFromLocalStorageDictionaryByProductID
				? this._ss.AllProductsFromLocalStorageDictionaryByProductID
				: products.reduce((acc, product) => ({ ...acc, [product.ProductId]: product }), {}),
		),
	);

	destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.EachClientEachHov = this._ss.EachClientEachHov;
		this.EachClientEachHov$.next(structuredClone(this.EachClientEachHov));
		this.OneClientInfo = this._ss.OneClientInfo;
		this.determineIfClientHasEmail();

		if (!this.clientHasEmail) {
			this.emailRadios.setValue('custom');
		}

		if (!this._ss.AllProductsFromLocalStorage) {
			const allProducts = localStorage.getItem('AllProducts');

			if (allProducts === null) {
				this.router.navigate(['clients']);
				return;
			}

			const parsed = JSON.parse(decompress(allProducts) ?? '[]');
			this.allProducts$.next(parsed);
			this._ss.AllProductsFromLocalStorage = parsed;
			this._ss.createAllProductsDictionary();
		} else {
			this.allProducts$.next(this._ss.AllProductsFromLocalStorage);
		}

		this.markProductsWithItemPicName();

		window.scrollTo(0, 0);

		if (localStorage.getItem('Admin') !== null) {
			this.Admin = localStorage.getItem('Admin');
		}

		if (this._ss.CustNum === '10152.1') {
			this._ss.SeeArizot = false;
		}

		if (this._ss.OneClientInfo === null) {
			this.router.navigate(['clients']);
		}

		this.showItemInPack = this._ss.CustomerInformation.HideQuantityInPack !== '1';

		console.log({ OneClientInfoDebt: this._ss.OneClientInfoDebt });
		console.log({ EachClientEachHov: this.EachClientEachHov });

		if (this._ss.CustomerInformation.CanSendEmail && this._ss.CustomerInformation.CanSendEmail.includes('4')) {
			this._ss.checkIfPDFExistInServer(this.pdfFolderLookup, this.EachClientEachHov?.[0]?.DocPicName).subscribe({
				next: (value: any) => {
					this.doesPDFExistInServer = true;
					this.pdfFilepath = this.formatStringWithEncodedSlashes(value.pdf);
				},
			});
		}

		this.form = this.fb.group({
			Client_Name: ['', Validators.required],
			Product_Name: ['', Validators.required],
			Amount: ['', Validators.required],
			Arizot: ['', Validators.required],
			OrderBy: ['', Validators.required],
			OrderByProducts: ['', Validators.required],
			HearaForOrder: ['', Validators.required],
			Anaha: ['', Validators.required],
			Ahozim: ['', Validators.required],
			TotalPrecentAllOrderSum: ['', Validators.required],
			OrderType: ['', Validators.required],
			OrderTypeBack: ['', Validators.required],
			HearaForOrderProduct: ['', Validators.required],
			AspakaDateForOrder: ['', Validators.required],
			bonus: ['', Validators.required],
			MahlakotType: ['', Validators.required],
		});

		// console.log({hovot:this._ss.OneClientInfoDebt});
	}

	ngAfterViewInit(): void {
		if (!this.searchInputComponent) return;
		this.EachClientEachHovDisplay$ = combineLatest([this.EachClientEachHov$, this.searchInputComponent.valueChanges.pipe(startWith('')), this.allProductsRecord$]).pipe(
			map(([hovot, searchValue, allProductsRecord]) => {
				if (!searchValue) return hovot;

				hovot = genericSearchingFunctionWithoutNullChecks(searchValue, hovot, ['DocItemName', 'DocItemCode']);

				for (const product of hovot) {
					product.ItemPicName ||= allProductsRecord[product.DocItemCode]?.ItemPicName;
				}

				return hovot;
			}),
		);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	public BackToClientHovot() {
		// this.router.navigate(['clienthovot'])
		history.back();
	}

	formatStringWithEncodedSlashes(str: string) {
		return str.replace(/\//g, '%2F').replace(/\\/g, '%5C');
	}

	handleClosePopup() {
		this.isEmailPickPopupOpen = this.emailSentSuccessfully = false;
	}

	determineIfClientHasEmail() {
		this.clientHasEmail = !this.OneClientInfo || Boolean(this.OneClientInfo.CustEmail || this.OneClientInfo.CustEMail);
	}

	loadingEmailSend = false;
	emailSentSuccessfully = false;

	handleSubmitEmail() {
		this.loadingEmailSend = true;
		let email = '';

		switch (this.emailRadios.value) {
			case 'client':
				email = this.OneClientInfo.CustEmail || this.OneClientInfo.CustEMail;
				break;
			case 'user':
				email = this._user.agentEmail$.value;
				break;
			case 'custom':
				email = this.emailInput.value;
				break;

			default:
				break;
		}

		this._ss.sendPDFThroughEmail(email, this.pdfFilepath, this.EachClientEachHov[0].DocDocNum).subscribe({
			next: res => {
				this.loadingEmailSend = false;
				this.emailSentSuccessfully = true;
			},
			error: err => {
				alert('ישנה תקלת תקשורת, אנא נסה שנית או מאוחר יותר.');
				this.loadingEmailSend = false;
			},
		});
	}

	markProductsWithItemPicName() {
		this.allProductsRecord$.pipe(take(1)).subscribe(allProductsRecord => {
			for (const product of this.EachClientEachHov$.value) {
				product.ItemPicName ||= allProductsRecord[product.DocItemCode]?.ItemPicName;
			}
		});
	}
}
